let csvw_url = "https://www.csvw.com";

let workspace4List = [
  {
    url: "https://news.yiche.com/xinchexiaoxi/20210828/1415021393.html",
    subtitle:
      "ID.3整车尺寸是 4261mm/1809mm/1552mm，轴距2765mm，外观上采用了ID.家族的家族设计语言，突出新能源车的属性，整体更具辨识度。",
    title: "/u/cms/www/202109/091453353006.png",
    titleMobile: "/u/cms/www/202109/091453353006.png",
    imgurl: "/u/cms/www/202109/091449345266.jpg",
    imgurlMobile: "/u/cms/www/202109/091429151564.jpg",
  },
  {
    url: "http://m.news18a.com/news/storys_156726.html",
    subtitle:
      "ID.3配备了IQ.Light矩阵式前大灯，不论是大灯本身的设计还是点亮后的效果都是十分出众的。",
    title: "/u/cms/www/202109/09145335NnFp.png",
    titleMobile: "/u/cms/www/202109/09145335NnFp.png",
    imgurl: "/u/cms/www/202109/091449475577.jpg",
    imgurlMobile: "/u/cms/www/202109/091429161fP0.jpg",
  },
  {
    url: "https://www.pcauto.com.cn/jxwd/2877/28770268.html",
    subtitle:
      "ID.3采用了银黑双色的低风阻样式轮毂，有较高的辨识度。配备的金边五角星样式的轮圈，造型也十分新颖。",
    title: "/u/cms/www/202109/09145335BRAT.png",
    titleMobile: "/u/cms/www/202109/09145335BRAT.png",
    imgurl: "/u/cms/www/202109/091453048k4f.jpg",
    imgurlMobile: "/u/cms/www/202109/09142915o8wN.jpg",
  },
  {
    url:
      "https://auto.sina.com.cn/newcar/x/2021-08-29/detail-iktzscyx1057672.shtml",
    subtitle:
      "ID.3车侧线条流畅，整体轮廓有些两厢车和MPV的跨界风格。车尾同样保持圆润风格，线条层次分明，尾灯造型与前大灯设计相呼应。",
    title: "/u/cms/www/202109/091453367wn3.png",
    titleMobile: "/u/cms/www/202109/091453367wn3.png",
    imgurl: "/u/cms/www/202109/091449557496.jpg",
    imgurlMobile: "/u/cms/www/202109/0914291645R0.jpg",
  },
  {
    url: "http://news.yiche.com/hao/wenzhang/52358945",
    subtitle:
      "ID.3大量运用“光”元素，具有鲜明的电动化汽车设计特征，采用了ID.家族的造型设计，拥有未来感十足镀光前脸，呈现立体光影轮廓。",
    title: "/u/cms/www/202109/09145335437C.png",
    titleMobile: "/u/cms/www/202109/09145335437C.png",
    imgurl: "/u/cms/www/202109/091449508AS9.jpg",
    imgurlMobile: "/u/cms/www/202109/09142916S96l.jpg",
  },
  {
    url: "https://mp.weixin.qq.com/s/8FtgFqIVuLPtrLIzDip_rQ",
    subtitle: "ID.3贯穿式LED灯带衔接能点亮的大众Logo，夜间出行极具辨识度。",
    title: "/u/cms/www/202109/09145336WH8d.png",
    titleMobile: "/u/cms/www/202109/09145336WH8d.png",
    imgurl: "/u/cms/www/202109/091449524Xlj.jpg",
    imgurlMobile: "/u/cms/www/202109/091429167510.jpg",
  },
  {
    url: "https://chejiahao.autohome.com.cn/info/9426991?r=20210831093730",
    subtitle:
      "ID.3保险杠的设计一改此前凶悍的气息，咧嘴一笑很呆萌，浮雕点阵的装饰也让前脸平添几分跳跃元素。",
    title: "/u/cms/www/202109/09145336l41s.png",
    titleMobile: "/u/cms/www/202109/09145336l41s.png",
    imgurl: "/u/cms/www/202109/09144954d1m4.jpg",
    imgurlMobile: "/u/cms/www/202109/09142917E17n.jpg",
  },
  {
    url: "https://chejiahao.autohome.com.cn/info/9416920",
    subtitle: "ID.3采用了拼色设计，后尾门为黑色涂装，与车身颜色形成对比。",
    title: "/u/cms/www/202109/09145336615v.png",
    titleMobile: "/u/cms/www/202109/09145336615v.png",
    imgurl: "/u/cms/www/202109/091449560T9H.jpg",
    imgurlMobile: "/u/cms/www/202109/091429164069.jpg",
  },
  {
    url: "https://mp.weixin.qq.com/s/x37niRiO1L6OSTEgPxYOug",
    subtitle:
      "ID.3搭载的AR HUD，能够把主要的驾驶参数，都清晰投射到驾驶席前风挡上。",
    title: "/u/cms/www/202109/091453363zcw.png",
    titleMobile: "/u/cms/www/202109/091453363zcw.png",
    imgurl: "/u/cms/www/202109/091449580N0O.jpg",
    imgurlMobile: "/u/cms/www/202109/09142917Q1Bv.jpg",
  },
  {
    url: "https://chejiahao.autohome.com.cn/info/9425588",
    subtitle:
      "ID.3车漆搭配方面，提供了极光绿、赛博黄、超导红、离子灰和晶质白5种颜色。",
    title: "/u/cms/www/202109/09145336622M.png",
    titleMobile: "/u/cms/www/202109/09145336622M.png",
    imgurl: "/u/cms/www/202109/091449579836.jpg",
    imgurlMobile: "/u/cms/www/202109/09142917Q974.jpg",
  },
  {
    url: "https://cheshihao.cheshi.com/news/580245.html",
    subtitle:
      "ID.3车内配备了10英寸悬浮式中控大屏，在贯穿式的立体雕塑感装饰面板映衬下，未来感不言而喻。",
    title: "/u/cms/www/202109/0914533652z4.png",
    titleMobile: "/u/cms/www/202109/0914533652z4.png",
    imgurl: "/u/cms/www/202109/0914500094HN.jpg",
    imgurlMobile: "/u/cms/www/202109/09142917Wk1o.jpg",
  },
].map((item) => {
  return {
    ...item,
    title: `${csvw_url}${item.title}`,
    titleMobile: `${csvw_url}${item.titleMobile}`,
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

export default {
  // kv
  workspace: {
    imgurl: `${csvw_url}/u/cms/www/202109/07181759T97t.png`,
    imgurlMobile: `${csvw_url}/u/cms/www/202109/08153446077n.png`,
  },
  // 车型介绍
  workspace1: {
    imgurl: `${csvw_url}/u/cms/www/202109/0718175340KC.png`,
    imgurlMobile: `${csvw_url}/u/cms/www/202109/08153447937a.png`,
    title: "ID.3",
    subtitle:
      "ID.3作为大众集团推出的首款基于MEB平台的纯电动车，开创了大众品牌电动车家族的先河，在欧洲市场已然成为“爆款”电动车。定位于打造品质与乐趣兼具的纯电跨界车，在潮趣、智趣、驾趣多方面将乐趣拉满的同时，还为消费者提供安心舒享的用电体验与实力传承的品质体验。",
  },
  // 车型素材
  workspace2: {
    imgurl: `${csvw_url}/u/cms/www/202109/07181814D956.png`,
    imgurlMobile: `${csvw_url}/u/cms/www/202109/17145719g07i.png`,
    wurl: `${csvw_url}/u/cms/www/202109/151733066T3u.png`,
    wurlMobile: `${csvw_url}/u/cms/www/202109/15173435784K.png`,
    nurl: `${csvw_url}/u/cms/www/202109/151733053469.png`,
    nurlMobile: `${csvw_url}/u/cms/www/202109/15173435Ken4.png`,
    qurl: `${csvw_url}/u/cms/www/202109/15173305hAu8.png`,
    qurlMobile: `${csvw_url}/u/cms/www/202109/15173435Lf33.png`,
    surl: `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
    surlMobile: `${csvw_url}/u/cms/www/202109/15173435u1Ms.png`,
    waiguan: Array.from({
      length: 9,
    }).map((item, i) => {
      return `${csvw_url}/u/cms/www/202109/15173310h02A.png`;
    }),
    neishi: Array.from({
      length: 9,
    }).map((item, i) => {
      return `${csvw_url}/u/cms/www/202109/15173310h02A.png`;
    }),
    qita: Array.from({
      length: 9,
    }).map((item, i) => {
      return `${csvw_url}/u/cms/www/202109/15173310h02A.png`;
    }),
    shipin: [
      `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
      `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
      `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
      `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
      `${csvw_url}/u/cms/www/202109/15173310h02A.png`,
    ],
    videourl: [
      csvw_url + "/u/cms/www/202106/151709349S84.mp4",
      csvw_url + "/u/cms/www/202106/03160934657Y.mp4",
      csvw_url + "/u/cms/www/202106/03160901qxpR.mp4",
      csvw_url + "/u/cms/www/202106/03160920y8d0.mp4",
      csvw_url + "/u/cms/www/202106/03160940480i.mp4",
    ],
  },
  // 新闻稿
  workspace3: {
    list: [
      {
        title: "ID.3上市新闻稿",
        title1: "",
        subtitle:
          "4月28日，上汽大众斯柯达“爆款”车型——全新明锐PRO正式开启预售。在备受瞩目的主题预售会中，“小明故事汇”拉开序幕，全新明锐PRO豪华版、尊贵版、旗舰版三款车型的预售价为：13.89万-15.99万元。",
        imgurl: `${csvw_url}/u/cms/www/202109/0718181171A3.png`,
        imgurlMobile: `${csvw_url}/u/cms/www/202109/0815345227Y5.png`,
        url:
          "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3066",
      },
      {
        title: "潮流单品驾到",
        title1: "纯电跨界车ID.3靓出界",
        subtitle:
          "欧洲电动车市场销冠、大众MEB平台首款纯电车，集多项光环于一身的ID.3刚刚亮相成都车展，就得到广泛关注。ID.3年轻化的潮感律动设计风格充满趣味，加上丰富的色彩应用与精致的细节打磨，让新车由内而外散发着独特的个性，满足消费者对潮流纯电车的想象。",
        imgurl: `${csvw_url}/u/cms/www/202109/17150236GX2j.png`,
        imgurlMobile: `${csvw_url}/u/cms/www/202109/17151648fEzD.png`,
        url:
          "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3144",
      },
      {
        title: "多重感官乐趣拉满",
        title1: "上汽大众全新纯电ID.3首发亮相并开启预订",
        subtitle:
          "8月29日，上汽大众品质乐趣纯电跨界车ID.3在成都车展亮相。ID.3作为大众集团推出的首款基于MEB平台的纯电动车，开创了大众品牌电动车家族的先河，在欧洲市场已然成为“爆款”电动车。",
        imgurl: `${csvw_url}/u/cms/www/202109/171502359IC8.png`,
        imgurlMobile: `${csvw_url}/u/cms/www/202109/1715164899n5.png`,
        url:
          "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3135",
      },
    ],
  },
  // 大咖点评
  workspace4: {
    list: workspace4List,
  },
  // 媒体试驾
  workspace5: {
    imgurl: `${csvw_url}/u/cms/www/202109/071817355goX.png`,
    imgurlMobile: `${csvw_url}/u/cms/www/202109/0815344713R3.png`,
    // 移动端
    shipin: [
      `${csvw_url}/u/cms/www/202109/151716361PqP.png`,
      `${csvw_url}/u/cms/www/202109/151716369KC8.png`,
      `${csvw_url}/u/cms/www/202109/15171636nu86.png`,
      `${csvw_url}/u/cms/www/202109/15171636p6L9.png`,
      `${csvw_url}/u/cms/www/202109/15171636a63O.png`,
      `${csvw_url}/u/cms/www/202109/15171637Dd12.png`,
    ],
    // PC端
    shipinPC: [
      [
        `${csvw_url}/u/cms/www/202109/151716361PqP.png`,
        `${csvw_url}/u/cms/www/202109/151716369KC8.png`,
        `${csvw_url}/u/cms/www/202109/15171636nu86.png`,
      ],
      [
        `${csvw_url}/u/cms/www/202109/15171636p6L9.png`,
        `${csvw_url}/u/cms/www/202109/15171636a63O.png`,
        `${csvw_url}/u/cms/www/202109/15171637Dd12.png`,
      ],
    ],
    videourl: [
      `${csvw_url}/u/cms/www/202109/10152532p0NS.mp4`,
      `${csvw_url}/u/cms/www/202109/101526171bo3.mp4`,
      `${csvw_url}/u/cms/www/202109/101524471c7x.mp4`,
      `${csvw_url}/u/cms/www/202109/1015281317Yf.mp4`,
      `${csvw_url}/u/cms/www/202109/10152928mORq.mp4`,
      `${csvw_url}/u/cms/www/202109/101657368Tf0.mp4`,
    ],
  },
  // 现场直击(作废板块)
  workspace6: {},
};
